<novo-data-table 
    [dataTableService]="remoteService"
    [columns]="sharedColumns"
    [allowMultipleFilters]="true"
    [displayedColumns]="sharedDisplayColumns"
    [hideGlobalSearch]="true"
    [selectionOptions]="selectionOptions"
    [paginationOptions]="paginationOptions"
    name="cubex-monster-jobs"
    [activeRowIdentifier]="selectedRecordId"
    *ngIf="!loading"
    #basic>
    <ng-template novoTemplate="sendingUser" let-row>
      <novo-value [data]="row.sendingUser" [meta]="ownerFieldMeta"></novo-value>
    </ng-template>
    <ng-template novoTemplate="jobOrder" let-row>
      <novo-value [data]="row.jobOrder" [meta]="jobFieldMeta"></novo-value>
    </ng-template>
    <ng-template novoTemplate="candidateOwner" let-row>
      <novo-value [data]="row.owner" [meta]="ownerFieldMeta"></novo-value>
    </ng-template>
    <ng-template novoTemplate="clientCorporation"
    let-row>
      <novo-value [data]="row.clientCorporation" [meta]="companyFieldMeta" ></novo-value>
    </ng-template>
    <ng-template novoTemplate="title"
    let-row>
      <novo-value [data]="row" [meta]="jobFieldMeta" ></novo-value>
    </ng-template>
  </novo-data-table>

<novo-loading *ngIf="loading" theme="line"></novo-loading>